import API from "../api";
import { apiCallbackTreatment } from "../auxiliary/generalFunctions";

const api = new API();

export default class WhatsappQuickMessagesController 
{
    async create(data) 
    {
        const response = await api.whatsappQuickMessages().post(data);
        return apiCallbackTreatment(response);
    }

    async update(data) 
    {
        const response = await api.whatsappQuickMessages().put(data);
        return apiCallbackTreatment(response);
    }

    async get() 
    {
        const response = await api.whatsappQuickMessages().get();
        return apiCallbackTreatment(response);
    }

    async getByFilters(filters) 
    {
        const response = await api.whatsappQuickMessages().getByFilters(filters);
        return apiCallbackTreatment(response);
    }

    async getDepartaments() 
    {
        const response = await api.whatsappQuickMessages().getDepartaments();
        return apiCallbackTreatment(response);
    }
}